/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as AgentRouteImport } from './app/routes/_agent'
import { Route as AgentIndexRouteImport } from './app/routes/_agent.index'
import { Route as AgentPoliciesRouteImport } from './app/routes/_agent.policies'
import { Route as AgentManageRouteImport } from './app/routes/_agent.manage'
import { Route as AgentPoliciesIndexRouteImport } from './app/routes/_agent.policies.index'
import { Route as AgentPoliciesNewRouteImport } from './app/routes/_agent.policies.new'
import { Route as AgentPoliciesEditPolicyIdRouteImport } from './app/routes/_agent.policies.edit.$policyId'

const AgentRoute = AgentRouteImport.update({
  id: '/_agent',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentIndexRoute = AgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentPoliciesRoute = AgentPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AgentRoute,
} as any)
const AgentManageRoute = AgentManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => AgentRoute,
} as any)
const AgentPoliciesIndexRoute = AgentPoliciesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentPoliciesRoute,
} as any)
const AgentPoliciesNewRoute = AgentPoliciesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AgentPoliciesRoute,
} as any)
const AgentPoliciesEditPolicyIdRoute =
  AgentPoliciesEditPolicyIdRouteImport.update({
    id: '/edit/$policyId',
    path: '/edit/$policyId',
    getParentRoute: () => AgentPoliciesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AgentIndexRoute
  '/manage': typeof AgentManageRoute
  '/policies': typeof AgentPoliciesRouteWithChildren
  '/policies/new': typeof AgentPoliciesNewRoute
  '/policies/': typeof AgentPoliciesIndexRoute
  '/policies/edit/$policyId': typeof AgentPoliciesEditPolicyIdRoute
}
export interface FileRoutesByTo {
  '/manage': typeof AgentManageRoute
  '/': typeof AgentIndexRoute
  '/policies/new': typeof AgentPoliciesNewRoute
  '/policies': typeof AgentPoliciesIndexRoute
  '/policies/edit/$policyId': typeof AgentPoliciesEditPolicyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_agent': typeof AgentRouteWithChildren
  '/_agent/manage': typeof AgentManageRoute
  '/_agent/policies': typeof AgentPoliciesRouteWithChildren
  '/_agent/': typeof AgentIndexRoute
  '/_agent/policies/new': typeof AgentPoliciesNewRoute
  '/_agent/policies/': typeof AgentPoliciesIndexRoute
  '/_agent/policies/edit/$policyId': typeof AgentPoliciesEditPolicyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/manage'
    | '/policies'
    | '/policies/new'
    | '/policies/'
    | '/policies/edit/$policyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/manage'
    | '/'
    | '/policies/new'
    | '/policies'
    | '/policies/edit/$policyId'
  id:
    | '__root__'
    | '/_agent'
    | '/_agent/manage'
    | '/_agent/policies'
    | '/_agent/'
    | '/_agent/policies/new'
    | '/_agent/policies/'
    | '/_agent/policies/edit/$policyId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AgentRoute: typeof AgentRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_agent': {
      id: '/_agent'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_agent/': {
      id: '/_agent/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AgentIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/_agent/policies': {
      id: '/_agent/policies'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof AgentPoliciesRouteImport
      parentRoute: typeof AgentRoute
    }
    '/_agent/manage': {
      id: '/_agent/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof AgentManageRouteImport
      parentRoute: typeof AgentRoute
    }
    '/_agent/policies/': {
      id: '/_agent/policies/'
      path: '/'
      fullPath: '/policies/'
      preLoaderRoute: typeof AgentPoliciesIndexRouteImport
      parentRoute: typeof AgentPoliciesRoute
    }
    '/_agent/policies/new': {
      id: '/_agent/policies/new'
      path: '/new'
      fullPath: '/policies/new'
      preLoaderRoute: typeof AgentPoliciesNewRouteImport
      parentRoute: typeof AgentPoliciesRoute
    }
    '/_agent/policies/edit/$policyId': {
      id: '/_agent/policies/edit/$policyId'
      path: '/edit/$policyId'
      fullPath: '/policies/edit/$policyId'
      preLoaderRoute: typeof AgentPoliciesEditPolicyIdRouteImport
      parentRoute: typeof AgentPoliciesRoute
    }
  }
}

interface AgentPoliciesRouteChildren {
  AgentPoliciesNewRoute: typeof AgentPoliciesNewRoute
  AgentPoliciesIndexRoute: typeof AgentPoliciesIndexRoute
  AgentPoliciesEditPolicyIdRoute: typeof AgentPoliciesEditPolicyIdRoute
}

const AgentPoliciesRouteChildren: AgentPoliciesRouteChildren = {
  AgentPoliciesNewRoute: AgentPoliciesNewRoute,
  AgentPoliciesIndexRoute: AgentPoliciesIndexRoute,
  AgentPoliciesEditPolicyIdRoute: AgentPoliciesEditPolicyIdRoute,
}

const AgentPoliciesRouteWithChildren = AgentPoliciesRoute._addFileChildren(
  AgentPoliciesRouteChildren,
)

interface AgentRouteChildren {
  AgentManageRoute: typeof AgentManageRoute
  AgentPoliciesRoute: typeof AgentPoliciesRouteWithChildren
  AgentIndexRoute: typeof AgentIndexRoute
}

const AgentRouteChildren: AgentRouteChildren = {
  AgentManageRoute: AgentManageRoute,
  AgentPoliciesRoute: AgentPoliciesRouteWithChildren,
  AgentIndexRoute: AgentIndexRoute,
}

const AgentRouteWithChildren = AgentRoute._addFileChildren(AgentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AgentRoute: AgentRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
